import SmkAsyncSelect from 'components/SmkAsyncSelect';
import { isEmpty } from 'lodash';
import React from 'react';
import { API_BASE_URL } from 'utils/constants';
import { htmlDecode } from 'utils/helper';

const CustomPageSearch = ({ onChange, value }) => {
  const handleSelectChange = (res) => {
    const currentPageMetaData = !isEmpty(value) ? value : [];

    const isAlreadySelected = currentPageMetaData?.some((item) => item?.id === res?.id);
    if (!isAlreadySelected) {
      const updatedPageMetaData = [
        ...currentPageMetaData,
        {
          title: res?.title,
          id: res?.id,
        },
      ];
      onChange(updatedPageMetaData);
    }
  };

  const handleRemoveItem = (id) => {
    const updatedPageMetaData = value?.filter((item) => item?.id !== id);
    onChange(updatedPageMetaData);
  };

  return (
    <>
      <div className="mb-3">
        <SmkAsyncSelect
          acceptedKey={'title'}
          acceptedValue={'id'}
          placeholder="Type page name.."
          onChange={handleSelectChange}
          fetchUrl={`${API_BASE_URL}/cms/admin/page/search`}
          filters={{
            autoComplete: true,
            page: 1,
            size: 20,
            sortBy: 'id',
            sortOrder: 0,
            dateType: 'createdDate',
            language: 'en',
            status: 'published',
            active: true,
            isStaticContent: true,
          }}
          searchKeyName="name"
        />
      </div>

      {!isEmpty(value) &&
        value?.map((item, index) => (
          <div
            key={item?.id}
            className="bg-light rounded-2 p-3 d-flex justify-content-between align-items-center mt-3  ">
            <h6 className="mb-0">
              {index + 1}. {htmlDecode(item?.title)}
            </h6>
            <button className="btn btn-md btn-danger" type="button" onClick={() => handleRemoveItem(item.id)}>
              Remove
            </button>
          </div>
        ))}
    </>
  );
};

export default CustomPageSearch;
